import { useZodFormFieldSingle } from '~/components/zod/ZodForm';
import InputSwitch, { InputSwitchProps } from '~/components/input/InputSwitch';

export default function ZodFieldSwitch({
  name,
  value,
  ...props
}: Omit<InputSwitchProps, 'on' | 'onChange'> & { name: string; value?: string }) {
  const [prefixed, zodValue, setValue] = useZodFormFieldSingle(name);

  return (
    <InputSwitch
      {...props}
      name={prefixed}
      on={zodValue === (value ?? 'true')}
      onChange={(on) => {
        setValue(on ? value ?? 'true' : '');
      }}
    />
  );
}
